import { useMagicKeys, whenever } from '@vueuse/core'
import { useRightyStore } from '../stores/rightyStore'

/**
 * Composable for global Righty keyboard shortcuts.
 *
 * - Cmd+J / Ctrl+J: Toggle Righty drawer
 * - Escape: Close Righty drawer (when open)
 *
 * Should be called once at the app level (e.g., in App.vue or a layout component).
 */
export function useRightyKeyboardShortcuts() {
  const rightyStore = useRightyStore()
  const keys = useMagicKeys()

  // Cmd+J (Mac) or Ctrl+J (Windows/Linux) to toggle
  const cmdJ = keys['Meta+j']
  const ctrlJ = keys['Ctrl+j']

  whenever(cmdJ, (pressed) => {
    if (pressed) {
      rightyStore.toggleDrawer()
    }
  })

  whenever(ctrlJ, (pressed) => {
    if (pressed) {
      rightyStore.toggleDrawer()
    }
  })

  // Escape to close (only when drawer is open)
  whenever(keys.escape, (pressed) => {
    if (pressed && rightyStore.isDrawerOpen) {
      rightyStore.closeDrawer()
    }
  })
}
